import { VersionConfigModel } from "./models/config";

export const VersionConfig: VersionConfigModel = {
  VERSION: "2.3.0.57",
  VERSION_CODE: 230057
};